import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    const role = localStorage.getItem("fixus_pending_role") || "homeowner";
    localStorage.removeItem("fixus_pending_role");

    api
      .post("/auth/google-session", { session_id: sessionId, role })
      .then(({ data }) => {
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}!`);
        // Clean URL hash
        window.history.replaceState(null, "", "/dashboard");
        nav(data.user.role === "tradesperson" && !data.user.profile?.city ? "/profile/edit" : "/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Try again.");
        nav("/login", { replace: true });
      });
  }, [nav, setUser]);

  return (
    <div className="min-h-[50vh] grid place-items-center text-slate-600" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
